import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('INPUT_PARTS', [
    'VIEW',
    'INFO',
    'HEADER',
    'FILTER_FORM'
])
